import React from "react";

import { workExperience } from "@/data";
import { Button } from "./ui/MovingBorders";

const Experience = () => {
  return (
    <div className="py-20 w-full">
      <h2 className="heading">
        Professional <span className="text-purple">Experience</span>
      </h2>

      <div className="w-full mt-12 grid lg:grid-cols-4 grid-cols-1 gap-10">
        {workExperience.map((card) => (
          <Button
            key={card.id}
            //   random duration will be fun , I think , may be not
            duration={Math.floor(Math.random() * 10000) + 10000}
            borderRadius="1.75rem"
            style={{
              //   add these two
              //   you can generate the color from here https://cssgradient.io/
              background: "rgb(4,7,29)",
              backgroundColor:
                "linear-gradient(90deg, rgba(4,7,29,1) 0%, rgba(12,14,35,1) 100%)",
              // add this border radius to make it more rounded so that the moving border is more realistic
              borderRadius: `calc(1.75rem* 0.96)`,
            }}
            // remove bg-white dark:bg-slate-900
            className="flex-1 text-black dark:text-white border-neutral-200 dark:border-slate-800"
          >
            <div className="flex lg:flex-row flex-col lg:items-center p-2 sm:p-3 md:p-4 lg:p-10 py-4 sm:py-6 gap-2 sm:gap-3 lg:gap-5">
              <img
                src={card.thumbnail}
                alt={card.title}
                className="lg:w-32 sm:w-24 md:w-20 w-16"
                loading="lazy"
                decoding="async"
              />
              <div className="lg:ms-5">
                <h3 className="text-start text-base sm:text-lg md:text-xl lg:text-2xl font-bold">
                  {card.title}
                </h3>
                {card.time && (
                  <p className="text-start text-blue-100 mt-1 text-sm font-semibold uppercase tracking-[0.08em]">
                    {card.time}
                  </p>
                )}
                <p className="text-start text-white-100 mt-2 sm:mt-3 text-xs sm:text-sm font-semibold">
                  {card.desc}
                </p>
              </div>
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default Experience;
